// profile/UpcomingEvents.jsx
import React from 'react';
import axios from 'axios';
import EventList from '../EventList';
import useCachedFetch from './hooks/useCachedFetch';

const UpcomingEvents = ({ user, isOwner }) => {

  const { data, loading, error, refetch } = useCachedFetch(
    `upcoming:${user?.id}`,
    async (signal) => {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/users/${user.id}/events/upcoming`, { signal });
      return res.data;
    },
    { enabled: !!user?.id, ttlMs: 60_000 }
  );

  const events = Array.isArray(data) ? data : [];

  if (loading) return <div>読み込み中...</div>;
  if (error) return <div>取得に失敗しました。<button onClick={refetch}>再読み込み</button></div>;
  if (!events.length) {
    return <div>イベントがありません。</div>;
  }

  return (
    <div>
      <EventList events={events} isOwner={isOwner} userId={user?.id} profileRole={user?.role} allowEdit={true} />
    </div>
  );
};

export default UpcomingEvents;
